import { getLatestOpportunities, saveLatestOpportunity } from '../../services/opportunities.service';

export const FETCH_LATEST_OPPORTUNITIES = 'FETCH_LATEST_OPPORTUNITIES';
export const FETCH_LATEST_OPPORTUNITIES_SUCCESS = 'FETCH_LATEST_OPPORTUNITIES_SUCCESS';

export const UPDATE_LATEST_OPPORTUNITIES = 'UPDATE_LATEST_OPPORTUNITIES';
export const UPDATE_LATEST_OPPORTUNITIES_SUCCESS = 'UPDATE_LATEST_OPPORTUNITIES_SUCCESS';

export function fetchLatestOpportunities() {
  return async dispatch => {
    dispatch({
      type: FETCH_LATEST_OPPORTUNITIES,
    });

    try {
      const latestOpportunities = await getLatestOpportunities();

      dispatch({
        type: FETCH_LATEST_OPPORTUNITIES_SUCCESS,
        latestOpportunities,
      });
    } catch (err) {
      dispatch({
        type: FETCH_LATEST_OPPORTUNITIES_SUCCESS,
        latestOpportunities: [],
      });
    }
  };
}

export function updateLatestOpportunities(opportunity) {
  return async (dispatch, getState) => {
    const currentState = getState().opportunity;
    const oldLatestOpportunities = currentState.latestOpportunities;

    // if opportunity already in latestOpportunities we need to move this to 1st place
    let opportunities = oldLatestOpportunities.filter(opp => opp.opportunityNumber !== opportunity.opportunityNumber);
    opportunities = [opportunity, ...opportunities].slice(0, 6);

    dispatch({
      type: UPDATE_LATEST_OPPORTUNITIES,
      latestOpportunities: opportunities,
    });

    try {
      await saveLatestOpportunity(opportunity);

      dispatch({
        type: UPDATE_LATEST_OPPORTUNITIES_SUCCESS,
      });
    } catch (err) {
      dispatch({
        type: UPDATE_LATEST_OPPORTUNITIES_SUCCESS,
        latestOpportunities: oldLatestOpportunities,
      });
    }
  };
}
